import type { TeamCompactness } from '@4cm/core/tactics/compactness';
import { HudChip } from './HudChip';

/**
 * Compactness gauges — two chips per team showing vertical (front-
 * to-back stretch) and horizontal (width) compactness in metres.
 *
 * Computed by `computeTeamCompactness` over outfielders only (GK
 * excluded). The chips show `null` as "—" rather than rendering with
 * stale numbers.
 *
 * Honours the master opponent toggle — pass `showAway={false}` from
 * the board to hide the away team's chips.
 */
export interface CompactnessChipsProps {
  home: TeamCompactness | null;
  away: TeamCompactness | null;
  showAway?: boolean;
}

function fmt(value: number | undefined): string {
  if (value === undefined || value === null || !Number.isFinite(value)) {
    return '—';
  }
  return `${Math.round(value)} m`;
}

export function CompactnessChips({
  home,
  away,
  showAway = true,
}: CompactnessChipsProps) {
  return (
    <>
      <HudChip
        ariaLabel={`Home vertical compactness ${fmt(home?.vertical)}`}
        onClick={() => undefined}
        team="home"
        active
      >
        H · Vert {fmt(home?.vertical)}
      </HudChip>
      <HudChip
        ariaLabel={`Home horizontal width ${fmt(home?.horizontal)}`}
        onClick={() => undefined}
        team="home"
        active
      >
        H · Wide {fmt(home?.horizontal)}
      </HudChip>
      {showAway && (
        <>
          <HudChip
            ariaLabel={`Away vertical compactness ${fmt(away?.vertical)}`}
            onClick={() => undefined}
            team="away"
            active
          >
            A · Vert {fmt(away?.vertical)}
          </HudChip>
          <HudChip
            ariaLabel={`Away horizontal width ${fmt(away?.horizontal)}`}
            onClick={() => undefined}
            team="away"
            active
          >
            A · Wide {fmt(away?.horizontal)}
          </HudChip>
        </>
      )}
    </>
  );
}
